/**
 * Company brochure upload service — matches /api/v1/company-brochures/upload.
 */
import api from './api';
import { ApiResponse } from '../types';
import { CompanyBrochureUploadResponse } from '../types/companyBrochure';

export async function uploadBrochure(
  file: File
): Promise<ApiResponse<CompanyBrochureUploadResponse>> {
  try {
    const fd = new FormData();
    fd.append('file', file);
    const response = await api.post('/company-brochures/upload', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      // Claude extraction can take 10-20s for image-heavy decks; give it
      // a longer ceiling than the default 30s.
      timeout: 120_000,
    });
    return { data: response.data };
  } catch (err: any) {
    return {
      error:
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.message ||
        'Failed to upload brochure',
    };
  }
}

const companyBrochureService = { uploadBrochure };
export default companyBrochureService;
